import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Sobre from '../views/Sobre.vue'
import Projetos from '../views/Projetos.vue'
import Contato from '../views/Contato.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/sobre', component: Sobre },
  { path: '/projetos', component: Projetos },
  { path: '/contato', component: Contato }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
